import { createSelector } from '@reduxjs/toolkit';
import { selectIsAuthenticated } from './auth.selector';

/**
 *
 * @param {*} state the app's state
 * @returns {import('../../../global').DesktopAppState}
 */
const desktopApp = (state) => state.desktopApp;

/**
 * Returns the volatile local manager API capability.
 */
export const managerApiTokenSelector = createSelector(
  desktopApp,
  (item) => item?.managerApiToken ?? ''
);

/**
 * Returns raw local GIMmanager transport connectivity.
 */
export const managerTransportConnectedSelector = createSelector(
  desktopApp,
  (item) => Boolean(item?.managerTransportConnected)
);

/**
 * Returns whether manager capability is ready for local API work.
 */
export const managerReadySelector = createSelector(
  [desktopApp, selectIsAuthenticated],
  (item, isAuthenticated) => Boolean(item?.managerReady) && isAuthenticated
);

/**
 * Selector for the latest GIMmanager version
 */
export const LatestGIMmanagerversionSelector = createSelector(
  desktopApp,
  (item) => item.latestAppVersion
);

/**
 *
 */
export const currentGIMmanagerversionSelector = createSelector(
  desktopApp,
  (item) => item.currentAppVersion
);

/**
 * Selector for whether an update is available or not
 */
export const GIMmanagerUpdateSelector = createSelector(
  desktopApp,
  (item) => item.appUpdateAvailable
);

/**
 * Selector for whether a mandatory update is available or not
 */
export const GIMmanagerUpdateMandatorySelector = createSelector(
  desktopApp,
  (item) => item.isUpdateMandatory
);

/**
 * Selector for whether or not to show the installer button
 */
export const ShowInstallerButtonSelector = createSelector(
  [managerTransportConnectedSelector],
  (isTransportConnected) => !isTransportConnected
);
